package com.patronat.top.error

import kotlinx.serialization.Serializable

@Serializable
enum class AppErrorCode(val value: String) {
    // --- AUTH & SECURITY ---
    INVALID_CREDENTIALS("invalid_credentials"),
    UNAUTHORIZED("unauthorized"),
    FORBIDDEN("forbidden"),
    TOKEN_EXPIRED("token_expired"),
    TOKEN_INVALID("token_invalid"),

    // --- MEDIA & FILES ---
    INVALID_MEDIA_TYPE("invalid_media_type"),

    // --- OTP SPECIFIC ---
    OTP_INVALID("otp_invalid"),
    OTP_EXPIRED("otp_expired"),
    OTP_LIMIT_EXCEEDED("otp_limit_exceeded"),

    // --- REGISTRATION & CONFLICTS ---
    EMAIL_IN_USE("email_in_use"),
    PHONE_IN_USE("phone_in_use"),
    INVALID_PROMO("invalid_promo"),

    // --- DATA & VALIDATION ---
    NOT_FOUND("not_found"),
    VALIDATION_ERROR("validation_error"),
    BAD_REQUEST("bad_request"),
    CONFLICT("conflict"),
    UNPROCESSABLE("unprocessable"),

    // --- NETWORK & SERVER ---
    NETWORK_OFFLINE("network_offline"),     
    TIMEOUT("timeout"),
    TOO_MANY_REQUESTS("too_many_requests"),
    SERVER_UNAVAILABLE("server_unavailable"),
    INTERNAL_ERROR("internal_error"),
    UNKNOWN("unknown");
}